import React from "react";
import { images } from "../mock";
import { Wrench, HeartHandshake, Sparkles } from "lucide-react";

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-6 relative">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] shadow-xl">
              <img src={images.about2} alt="Mehrfamilienhaus einer Eigentümergemeinschaft" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-8 -right-4 md:right-8 w-56 h-56 rounded-3xl overflow-hidden shadow-2xl border-4 border-white hidden md:block">
              <img src={images.about1} alt="Wohnanlage in der WEG-Verwaltung" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -top-6 -left-6 bg-brand-900 text-white rounded-2xl px-6 py-5 shadow-xl hidden md:block">
              <div className="font-display text-3xl font-extrabold">10 Werktage</div>
              <div className="text-[12px] uppercase tracking-wider text-brand-200">Abrechnungsgarantie</div>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="text-[12px] tracking-[0.3em] uppercase text-accent2 font-semibold">
              Über uns
            </div>
            <h2 className="mt-3 font-display text-[36px] md:text-[46px] leading-tight font-extrabold text-brand-900">
              Aus dem Handwerk. Für Ihre Immobilie.
            </h2>
            <p className="mt-5 text-brand-700 leading-relaxed">
              Wir verstehen nicht nur die Zahlen, sondern auch die Technik Ihrer Immobilie.
              Instandhaltungsbedarf erkennen wir frühzeitig, Handwerkerangebote prüfen wir
              fachkundig und Reparaturen koordinieren wir zügig und wirtschaftlich.
            </p>
            <p className="mt-4 text-brand-700 leading-relaxed">
              Unser Schwerpunkt liegt auf der WEG-Verwaltung kleiner und mittelgroßer
              Eigentümergemeinschaften in Kleve und am Niederrhein – mit festem
              Ansprechpartner, kurzen Wegen und transparenten Abläufen.
            </p>

            <div className="mt-8 grid sm:grid-cols-3 gap-4">
              {[
                { icon: Wrench, title: "Handwerks-DNA", text: "Breites Netzwerk geprüfter Handwerksbetriebe." },
                { icon: HeartHandshake, title: "Persönlich", text: "Sie kennen Ihren Ansprechpartner." },
                { icon: Sparkles, title: "Erfahrung", text: "Mehrjährige Praxis in der WEG-Verwaltung." },
              ].map((f) => (
                <div
                  key={f.title}
                  className="rounded-2xl border border-brand-100 p-5 hover:border-brand-300 hover:shadow-md transition-all"
                >
                  <div className="w-10 h-10 rounded-xl bg-brand-50 flex items-center justify-center text-brand-800">
                    <f.icon className="w-5 h-5" />
                  </div>
                  <div className="mt-3 font-semibold text-brand-900">{f.title}</div>
                  <div className="text-[13px] text-brand-600 mt-1">{f.text}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
